import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ProductDetailPage = lazy(() => import('../pages/product-detail/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const MigrationPage = lazy(() => import('../pages/migration/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/product/:size',
    element: <ProductDetailPage />,
  },
  {
    path: '/checkout',
    element: <CheckoutPage />,
  },
  {
    path: '/migration',
    element: <MigrationPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;